const ProjectTask = {
    project: "",
    task: "",
  };
  
  export default ProjectTask;